/**
 * 认证服务入口
 * 统一使用PermissionService进行权限管理
 */

export { PermissionService } from '@/services/n8n/permission';
export type { UserInfo, UserRole } from '@/types';
export { AuthService } from './authService';
